import axios from 'axios';
import { constantApp } from '../config/constant';

// export const getPeople = () => {
//     return {
//         type: "GET_PEOPLE",
//         payload: "Hey Yo"
//     }
// };



export const getPeople = () => {
    let url = `${constantApp.SERVERIP}/APAFAN/PHP/Produce/Select_Produce.php`;

    let getPeople = axios.post(url)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            // this.setState({ isNetworkError: true })
            // console.log('error :::', error)
        });

    return {
        type: "GET_PEOPLE",
        payload: getPeople
    }
};